var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.computedClass,attrs:{"id":_vm.id}},[(_vm.swiftMove)?_c('v-icon',{attrs:{"color":"white darken-2"}},[_vm._v("verified")]):_vm._e(),(_vm.swiftMove)?_c('span',[_vm._v(" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }